import api from "../../http";

export default class ApiSolutionsCasinoFirstSection {
    static async getApiSolutionsCasinoFirstSection(url) {
        return api.get(url)
    }
}